export const CASHING_UP_STATUS_OPTIONS = [
  { value: "OPEN", label: "Open" },
  { value: "CLOSED", label: "Closed" },
  { value: "VARIANCE_PENDING", label: "Variance Pending" },
];

export const getDefaultCashingUpFilters = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return {
    storeId: "",
    businessDate: `${year}-${month}-${day}`,
    from: `${year}-${month}-${day}`,
    to: `${year}-${month}-${day}`,
    tillId: "",
    statuses: [],
    limit: 20,
  };
};

export const normalizeCashingUpCollection = (data, keys = []) => {
  if (Array.isArray(data)) {
    return data;
  }

  for (const key of keys) {
    if (Array.isArray(data?.[key])) {
      return data[key];
    }
  }

  return [];
};

export const formatSignedCurrency = (amount, currencyCode = "USD") => {
  const value = Number(amount || 0);
  const absolute = Math.abs(value);
  try {
    const formatted = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currencyCode || "USD",
      maximumFractionDigits: 2,
    }).format(absolute);
    return value < 0 ? `-${formatted}` : formatted;
  } catch (error) {
    return `${value < 0 ? "-" : ""}${currencyCode || "USD"} ${absolute.toFixed(2)}`;
  }
};

export const formatAmountWithImpact = (amount, currencyCode = "USD") => {
  const value = Number(amount || 0);
  const tone = value < 0 ? "rose" : value > 0 ? "emerald" : "slate";
  return {
    value: formatSignedCurrency(value, currencyCode),
    tone,
  };
};

export const getCashImpactTone = (amount) =>
  Number(amount || 0) < 0 ? "rose" : Number(amount || 0) > 0 ? "emerald" : "slate";

export const getStatusTone = (status) => {
  const normalized = String(status || "").toUpperCase();
  if (["CLOSED", "APPROVED"].includes(normalized)) return "success";
  if (["OPEN", "PENDING", "CASH_UP_IN_PROGRESS", "COUNT_SUBMITTED", "VARIANCE_PENDING"].includes(normalized)) {
    return "warning";
  }
  if (["REJECTED", "VOIDED"].includes(normalized)) return "danger";
  if (["REOPENED"].includes(normalized)) return "info";
  return "neutral";
};

export const formatStatusLabel = (status) =>
  String(status || "-")
    .replace(/_/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());

export const getCashingUpExportParams = (filters) => {
  const params = {
    storeId: filters.storeId,
    businessDate: filters.businessDate,
    from: filters.from,
    to: filters.to,
    tillId: filters.tillId,
    statuses: filters.statuses,
    limit: filters.limit,
  };

  Object.keys(params).forEach((key) => {
    if (
      params[key] === undefined ||
      params[key] === null ||
      params[key] === "" ||
      (Array.isArray(params[key]) && params[key].length === 0)
    ) {
      delete params[key];
    }
  });

  return params;
};
